import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { Resetable } from '../../resetter/resetable';
import { InitializeAware, InitializeStatus } from '../../initialize/initialize-aware';
import { Message } from 'src/app/_model/message';

@Injectable()
export abstract class MessagesService implements Resetable, InitializeAware {

  public messages$: BehaviorSubject<Message[]>;

  public abstract addMessage(message: Message): Promise<void>;
  public abstract setMessageToRead(message: Message): Promise<void>;

  // Resetable
  public abstract reset(): Promise<void>;
  public abstract clear(): Promise<void>;

  // Initialize Aware
  public initializeStatus$: BehaviorSubject<InitializeStatus>;
  abstract initialize(): Promise<void>
  abstract initializeCompleted(): Promise<void>
}
